module.exports = __webpack_public_path__ + "static/media/insurance.a8cb9b62.png";